<div class="row">
    <div class="col-md-12">

        <nav class="nav nav-pills nav-fill">
            <a class="nav-link active" data-toggle="pill" data-target="#pills-socios" type="button"
                    role="tab" aria-controls="pills-socios" aria-selected="true" >Socios</a>
            <a class="nav-link"data-toggle="pill" data-target="#pills-afiliados" type="button"
                    role="tab" aria-controls="pills-afiliados" aria-selected="false">Afiliados</a>
            <a class="nav-link" id="pills-mesa-tab" data-toggle="pill" data-target="#pills-mesa" type="button"
                    role="tab" aria-controls="pills-mesa" aria-selected="false">Mesa DIrectiva</a>
        </nav>
        <div class="tab-content" id="pills-tabContent">
            <!-- Socios -->
            <div class="tab-pane fade show active" id="pills-socios" role="tabpanel" aria-labelledby="pills-socios-tab">
                <div class="cardBloque ">
                    <h1 style="text-align: center; color: black; font-weight: bolder;" class="titlesSize">ASOCIADOS</h1>
                
                    <div class="row">
                        <div class="col-md-4 col-12 mb-1">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Buscar" aria-describedby="button-addon2"
                                    style="border-radius:20px 0px 0px 20px;" [(ngModel)]="search" />
                                <div class="input-group-append" id="button-addon2">
                                    <button type="button" class="btn btn-icon btn-outline-primary"
                                        style="border-radius:0px 20px 20px 0px;" rippleEffect (click)="searchPartners()">
                                        <span [data-feather]="'search'"></span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                
                
                    <ng-container *ngIf="partners.length > 0 && bandShow">
                        <div class="row">
                            <div class="col-md-3" *ngFor="let par of paginatedPartners">
                                <div class="card colorLandingCard">
                                    <div class="card-body">
                                        <div class="d-flex justify-content-center">
                                            <div class="img-bord">
                                                <img *ngIf="par.logo!= null" class="img-circP"  [src]="url+par.logo" alt="banner"
                                                    [ngStyle]="{'cursor':par.url?'pointer':''}" (click)="sendWebPage(par.url)">
                                                <img *ngIf="par.logo == null" class="img-circP" src="../../../../../assets/images/logo/perfil.png" alt="banner"
                                                        [ngStyle]="{'cursor':par.url?'pointer':''}" (click)="sendWebPage(par.url)">
                                            </div>
                                        </div>
                
                                        <div class="containTextPartTitle">
                                            <a *ngIf="par.url_inmo != null" class="text-primary" (click)="tarjetaDigital(par.url_inmo)">
                                                <h3 class="text-center text-dark mt-1">{{par.name}}</h3>
                                            </a>
                                            <a *ngIf="par.url_inmo == null">
                                                <h3 class="text-center text-dark mt-1">{{par.name}}</h3>
                                            </a>
                                        </div>
                                        <div *ngIf="par.position" class="text-center">
                                            <span class="badge badge-pill badge-primary">{{par.position}} </span>
                                        </div>
                
                                        <div class="containTextPart">
                                            <p class="card-text mt-1 ">
                                                Ubicación: {{par.province+', '+par.state}}
                                                <br>
                                                Teléfono: {{par.phone | slice:0:3
                                                }}-{{par.phone | slice:3:6
                                                }}-{{par.phone |
                                                slice:6:10 }}
                                                <br>
                                                Email: {{par.email}}
                                            </p>
                                        </div>
                
                                        <div style="height: 40px;">
                                            <div class="d-flex justify-content-center mt-1">
                                                <ng-container *ngIf="par.isWhatsApp">
                                                    <button type="button" class="btn btn-icon btn-icon rounded-circle colorWhatsApp"
                                                        style="color:white; font-size: 25px" rippleEffect
                                                        (click)="sendWhatsApp(par.phone)">
                                                        <i class="fa fa-whatsapp" aria-hidden="true"></i></button>
                                                </ng-container>
                                            </div>
                                        </div>
                
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 text-center">
                                <button class="btn btn-primary" (click)="goToPage(currentPage - 1)"
                                    [disabled]="currentPage === 1">Anterior</button>
                            </div>
                            <div class="col-md-6 text-center">
                                <button class="btn btn-primary" (click)="goToPage(currentPage + 1)"
                                    [disabled]="currentPage * pageSize >= partners.length">Siguiente</button>
                            </div>
                        </div>
                
                    </ng-container>
                    <ng-container *ngIf="partners.length == 0 && bandShow">
                        <h3 class="mt-1 text-center">No hay resultados</h3>
                    </ng-container>
                    <div class="row mt-5">
                        <div class="col-md-12 text-center">
                            <a href="/socios" class="btn btn-primary">+</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Afiliados -->
            <div class="tab-pane fade" id="pills-afiliados" role="tabpanel" aria-labelledby="pills-afiliados-tab">
                <div class="cardBloque ">
                    <h1 style="text-align: center; color: black; font-weight: bolder;" class="titlesSize">Afiliados</h1>
                
                    <div class="row">
                        <div class="col-md-4 col-12 mb-1">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Buscar" aria-describedby="button-addon2"
                                    style="border-radius:20px 0px 0px 20px;" [(ngModel)]="search" />
                                <div class="input-group-append" id="button-addon2">
                                    <button type="button" class="btn btn-icon btn-outline-primary"
                                        style="border-radius:0px 20px 20px 0px;" rippleEffect (click)="searchAffiliates()">
                                        <span [data-feather]="'search'"></span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                
                
                    <ng-container *ngIf="affiliates.length > 0 && bandShow">
                        <div class="row">
                            <div class="col-md-3" *ngFor="let par of paginatedAffiliates">
                                <div class="card colorLandingCard">
                                    <div class="card-body">
                                        <div class="d-flex justify-content-center">
                                            <div class="img-bord"><img class="img-circP" [src]="url+par.logo" alt="banner"
                                                    [ngStyle]="{'cursor':par.url_web?'pointer':''}" (click)="sendWebPage(par.url_web)">
                                            </div>
                                        </div>
                
                                        <div class="containTextPartTitle">
                                            <a *ngIf="par.instagram != null" class="text-primary" (click)="tarjetaDigital(par.instagram)">
                                                <h3 class="text-center text-dark mt-1">{{par.name}}</h3>
                                            </a>
                                            <a *ngIf="par.instagram == null">
                                                <h3 class="text-center text-dark mt-1">{{par.name}}</h3>
                                            </a>
                                        </div>
                                        <div *ngIf="par.position" class="text-center">
                                            <span class="badge badge-pill badge-primary">{{par.position}} </span>
                                        </div>
                
                                        <div class="containTextPart">
                                            <p class="card-text mt-1 ">
                                                <!-- Ubicación: {{par.street+', #'+par.noExt+', '+par.province+', '+par.state}} -->
                                                <br>
                                                Teléfono: {{par.phone | slice:0:3
                                                }}-{{par.phone | slice:3:6
                                                }}-{{par.phone |
                                                slice:6:10 }}
                                                <br>
                                                Email: {{par.email}}
                                            </p>
                                        </div>
                
                                        <div style="height: 40px;">
                                            <div class="d-flex justify-content-center mt-1">
                                                <ng-container *ngIf="par.isWhatsApp">
                                                    <button type="button" class="btn btn-icon btn-icon rounded-circle colorWhatsApp"
                                                        style="color:white; font-size: 25px" rippleEffect
                                                        (click)="sendWhatsApp(par.phone)">
                                                        <i class="fa fa-whatsapp" aria-hidden="true"></i></button>
                                                </ng-container>
                                            </div>
                                        </div>
                
                                    </div>
                                </div>
                                <!-- Add Pagination -->
                                <div class="swiper-pagination"></div>
                
                            </div>
                
                            <!-- Controles de Paginación -->
                        </div>
                        <div class="row">
                            <div class="col-md-6 text-center">
                                <button class="btn btn-primary" (click)="goToPage(currentPage - 1)"
                                    [disabled]="currentPage === 1">Anterior</button>
                            </div>
                            <div class="col-md-6 text-center">
                                <button class="btn btn-primary" (click)="goToPage(currentPage + 1)"
                                    [disabled]="currentPage * pageSize >= affiliates.length">Siguiente</button>
                            </div>
                        </div>
                
                    </ng-container>
                    <ng-container *ngIf="affiliates.length == 0 && bandShow">
                        <h3 class="mt-1 text-center">No hay resultados</h3>
                    </ng-container>
                    <!-- <div class="row mt-5">
                        <div class="col-md-12 text-center">
                            <a href="/socios" class="btn btn-primary">Ver Mas...</a>
                        </div>
                    </div> -->
                
                
                
                </div>
            </div>
            <!-- Mesa Directiva -->
            <div class="tab-pane fade" id="pills-mesa" role="tabpanel" aria-labelledby="pills-mesa-tab">
                <div class="cardBloque ">
                    <h1 style="text-align: center; color: black; font-weight: bolder;" class="titlesSize">Mesa Directiva</h1>
                
                    <!-- <div class="row">
                        <div class="col-md-4 col-12 mb-1">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Buscar" aria-describedby="button-addon2"
                                    style="border-radius:20px 0px 0px 20px;" [(ngModel)]="search" />
                                <div class="input-group-append" id="button-addon2">
                                    <button type="button" class="btn btn-icon btn-outline-primary"
                                        style="border-radius:0px 20px 20px 0px;" rippleEffect (click)="searchPartners()">
                                        <span [data-feather]="'search'"></span></button>
                                </div>
                            </div>
                        </div>
                    </div> -->
                
                
                    <ng-container *ngIf="mesaDirectiva.length > 0 && bandShow">
                        <div class="row">
                            <div class="col-md-3" *ngFor="let par of paginatedMesaDirectiva">
                                <div class="card colorLandingCard">
                                    <div class="card-body">
                                        <div class="d-flex justify-content-center">
                                            <div class="img-bord"><img class="img-circP" [src]="url+par.logo" alt="banner"
                                                    [ngStyle]="{'cursor':par.url?'pointer':''}" (click)="sendWebPage(par.url)">
                                            </div>
                                        </div>
                
                                        <div class="containTextPartTitle">
                                            <a *ngIf="par.url_inmo != null" class="text-primary" (click)="tarjetaDigital(par.url_inmo)">
                                                <h3 class="text-center text-dark mt-1">{{par.name}}</h3>
                                            </a>
                                            <a *ngIf="par.url_inmo == null">
                                                <h3 class="text-center text-dark mt-1">{{par.name}}</h3>
                                            </a>
                                        </div>
                                        <div *ngIf="par.position" class="text-center">
                                            <span class="badge badge-pill badge-primary">{{par.position}} </span>
                                        </div>
                
                                        <div class="containTextPart">
                                            <p class="card-text mt-1 ">
                                                <!-- Ubicación: {{par.street+', #'+par.noExt+', '+par.province+', '+par.state}} -->
                                                <br>
                                                Teléfono: {{par.phone | slice:0:3
                                                }}-{{par.phone | slice:3:6
                                                }}-{{par.phone |
                                                slice:6:10 }}
                                                <br>
                                                Email: {{par.email}}
                                            </p>
                                        </div>
                
                                        <div style="height: 40px;">
                                            <div class="d-flex justify-content-center mt-1">
                                                <ng-container *ngIf="par.isWhatsApp">
                                                    <button type="button" class="btn btn-icon btn-icon rounded-circle colorWhatsApp"
                                                        style="color:white; font-size: 25px" rippleEffect
                                                        (click)="sendWhatsApp(par.phone)">
                                                        <i class="fa fa-whatsapp" aria-hidden="true"></i></button>
                                                </ng-container>
                                            </div>
                                        </div>
                
                                    </div>
                                </div>
                
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 text-center">
                                <button class="btn btn-primary" (click)="goToPage(currentPage - 1)"
                                    [disabled]="currentPage === 1">Anterior</button>
                            </div>
                            <div class="col-md-6 text-center">
                                <button class="btn btn-primary" (click)="goToPage(currentPage + 1)"
                                    [disabled]="currentPage * pageSize >= partners.length">Siguiente</button>
                            </div>
                        </div>
                
                    </ng-container>
                    <ng-container *ngIf="partners.length == 0 && bandShow">
                        <h3 class="mt-1 text-center">No hay resultados</h3>
                    </ng-container>
                
                
                
                
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
    </div>
</div>